/*
 *
 * QualitativeQuestionList actions
 *
 */

import {
  GET_QUALITATIVE_ANSWERS_WATCHER,
  GET_QUALITATIVE_ANSWERS_SUCCESS,
  GET_QUALITATIVE_ANSWERS_FAILED,
  GET_QUALITATIVE_ANSWERS_WORDCLOUD_FAILED,
  GET_QUALITATIVE_ANSWERS_WORDCLOUD_SUCCESS,
  GET_QUALITATIVE_ANSWERS_WORDCLOUD_WATCHER,
  GET_QUALITATIVE_ANSWERS_SENTIMENT_WORDCLOUD_SUCCESS,
} from "./constants"

/* Anwers */
export function getQualitativeAnswersWatcher(payload) {
  return {
    type: GET_QUALITATIVE_ANSWERS_WATCHER,
    payload,
  }
}

export function getQualitativeAnswersSuccess(payload) {
  return {
    type: GET_QUALITATIVE_ANSWERS_SUCCESS,
    payload,
  }
}

export function getQualitativeAnswersFailed() {
  return { type: GET_QUALITATIVE_ANSWERS_FAILED }
}

/* WordCloud */
export function getQualitativeAnswersWordcloudWatcher(payload) {
  return {
    type: GET_QUALITATIVE_ANSWERS_WORDCLOUD_WATCHER,
    payload,
  }
}

export function getQualitativeAnswersWordCloudSuccess(payload) {
  return {
    type: GET_QUALITATIVE_ANSWERS_WORDCLOUD_SUCCESS,
    payload,
  }
}

export function getQualitativeAnswersWordcloudFailed() {
  return {
    type: GET_QUALITATIVE_ANSWERS_WORDCLOUD_FAILED,
  }
}

/* Sentiment wordcloud */
export function getQualitativeAnswersSentimentWordcloudSuccess(payload) {
  return {
    type: GET_QUALITATIVE_ANSWERS_SENTIMENT_WORDCLOUD_SUCCESS,
    payload,
  }
}
